var map = {
	"./symbol_0.png": "773c",
	"./symbol_1.png": "6165",
	"./symbol_2.png": "8dac",
	"./symbol_3.png": "849b",
	"./symbol_4.png": "2a49",
	"./symbol_5.png": "ad0c",
	"./symbol_6.png": "0c1c",
	"./symbol_7.png": "9863"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b198";